class FaqItem {
  constructor(faqItem, questionClass, answerClass, activeClass) {
    this.faq = faqItem;
    this.question = faqItem.querySelector(questionClass);
    this.answer = faqItem.querySelector(answerClass);
    this.activeClass = activeClass;
  }

  init() {
    this.answer.style.height = this.answer.getBoundingClientRect().height;
    this.faq.classList.remove(this.activeClass);

    this.question.addEventListener("click", () => {
      this.toggleFaq();
    });
  }

  toggleFaq() {
    this.faq.classList.toggle(this.activeClass);
  }
}

export default FaqItem;
